export default "__VITE_ASSET__UdtAC4AO__"